var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNew = function SvgNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#new_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.164A3 3 0 0 1 3.16.17L33.07 1.764c2.12.113 3.456 2.333 2.561 4.259L31.697 14.5a3 3 0 0 1-2.337 1.712L3.384 19.563A3 3 0 0 1 0 16.588V3.164Z",
    fill: "url(#new_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.913 13V5.3h1.474l4.543 5.544h-.715V5.3h1.76V13h-1.463L5.958 7.456h.715V13h-1.76Zm11.48.088c-.675 0-1.269-.132-1.782-.396a2.941 2.941 0 0 1-1.177-1.078 2.985 2.985 0 0 1-.418-1.573c0-.594.136-1.118.407-1.573a2.912 2.912 0 0 1 1.133-1.078 3.281 3.281 0 0 1 1.617-.396c.58 0 1.1.125 1.562.374.47.242.84.594 1.11 1.056.272.455.408 1.001.408 1.639 0 .066-.004.143-.011.231l-.022.231h-4.807V9.524h3.905l-.66.297c0-.308-.063-.576-.187-.803a1.327 1.327 0 0 0-.517-.528 1.468 1.468 0 0 0-.77-.198c-.294 0-.554.066-.781.198a1.31 1.31 0 0 0-.517.539 1.669 1.669 0 0 0-.187.814v.264c0 .323.07.609.209.858.147.242.348.429.605.561.264.125.572.187.924.187.315 0 .59-.048.825-.143.242-.095.462-.238.66-.429l.913.99a2.711 2.711 0 0 1-1.023.715c-.41.161-.884.242-1.42.242ZM21.42 13l-2.134-5.918h1.617l1.77 5.093h-.77l1.849-5.093h1.452l1.793 5.093h-.77l1.826-5.093h1.518L27.427 13h-1.661l-1.573-4.367h.506L23.07 13h-1.65Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "new_svg__b",
    x1: 41.5,
    y1: -6,
    x2: -8,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F953C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B91D73",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "new_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h37.5v20H0z"
  })))));
};
export default SvgNew;